module.exports = __webpack_public_path__ + "static/media/empty-bookmarked.77385530.svg";